<template>
  <el-dropdown class="table-sort" @command="command">
    <span class="el-dropdown-link">
      {{ title }}
      <i class="el-icon-arrow-down el-icon--right" />
    </span>
    <el-dropdown-menu slot="dropdown">
      <template v-for="(item, index) in dropdowns">

        <el-dropdown-item
          :key="'ascending' + index"
          :command="{ prop: item.prop, order: 'ascending' }"
          :class="{ 'active-sort': item.prop === prop && order === 'ascending' }"
        >
          <div class="table-sort-cell">
            <div class="table-sort-lebal">{{ $t(item.label) }}</div>
            <div class="table-sort-order">{{ $t('table.ascending') }}</div>
          </div>
        </el-dropdown-item>

        <el-dropdown-item
          :key="'descending' + index"
          :command="{ prop: item.prop, order: 'descending' }"
          :class="{ 'active-sort': item.prop === prop && order === 'descending' }"
        >
          <div class="table-sort-cell">
            <div class="table-sort-lebal">{{ $t(item.label) }}</div>
            <div class="table-sort-order">{{ $t('table.descending') }}</div>
          </div>
        </el-dropdown-item>

      </template>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
const orderMap = new Map([
  ['desc', 'descending'],
  ['asc', 'ascending']
])
export default {
  props: {
    column: {
      type: Array,
      default: () => []
    },
    sort: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      prop: undefined,
      order: orderMap.get(this.sort.order)
    }
  },
  computed: {
    dropdowns() {
      return this.column.filter(item => item.sortable === 'custom')
    },
    activeItem() {
      return this.dropdowns.filter(item => item.prop === this.sort.field)[0]
    },
    title() {
      if (!this.activeItem) return this.$t('table.sort')
      const label = this.$t(this.activeItem.label)
      const sort = this.order ? this.$t(`table.${this.order}`) : ''
      return `${label} ${sort}`
    }
  },
  methods: {
    command(data) {
      this.order = data && data.order
      this.prop = data && data.prop
      this.$emit('sort-change', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-dropdown-link {
  color: #333333;
  font-size: 12px;
}
.table-sort {
  &-cell {
    min-width: 130px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.active-sort {
  background-color: #e6f4fc;
  color: #35a5e9;
}
</style>
